<footer class="flex items-center w-full bg-default-50">
  <div
    class="mx-16 w-full flex justify-between items-center px-24 py-8 body-m roboto-regular-font lh-20"
  >
    <p>©{{ currentYear }} The Kroger Co. All Rights Reserved</p>
    <div *ngIf="!isProd">
      <p>Build Number : {{ buildNumber }}</p>
    </div>
  </div>
</footer>
